document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.tribe-events-subscribe-dropdown .dropdown__button-text');

    buttons.forEach(function(button) {
        button.addEventListener('click', function(event) {
            const parentDropdown = this.closest('.subscribe--dropdown');
            if (parentDropdown) {
                parentDropdown.classList.toggle('active');
            }
            event.stopPropagation();
        });
    });

    document.body.addEventListener('click', function(event) {
        const dropdowns = document.querySelectorAll('.subscribe--dropdown');
        dropdowns.forEach(function(dropdown) {
            if (!dropdown.contains(event.target)) {
                dropdown.classList.remove('active');
            }
        });
    });
});
